import {useApi} from "../Api";
import {FormSearchProductCodeModel, ProductCodeEntityResponse} from "../types/productCode";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";

export const useProductCodeRepository = () => {
    const {GET} = useApi();

    const PATH = "/pricing/product-code";


    function getProductCode(id: string): Promise<ProductCodeEntityResponse> {
        return GET(`${PATH}?id=${id}`);
    }

    function getProductCodes(legalEntities:string, dealers:string): Promise<ProductCodeEntityResponse[]> {
        return GET(`${PATH}/filter?legalEntities=${legalEntities}&dealers=${dealers}`);
    }

    function getPagedProductCode(filters: FormSearchProductCodeModel): Promise<PagedResponse<ProductCodeEntityResponse>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/paged-product-code${queryParams ? query + queryParams : ""}`);
    }

    function getProductCodesByCommercialCategoryId(commercialCategoryId: string, dealers: string | string[], legalEntities: string | string[]): Promise<ProductCodeEntityResponse[]> {
        return GET(`${PATH}/by-commercial-category?commercialCategoryId=${commercialCategoryId}&dealers=${dealers}&legalEntities=${legalEntities} `);
    }

    function getCustomProductCode(dealer: string, legalEntity: string): Promise<PagedResponse<ProductCodeEntityResponse>> {
        return GET(`${PATH}/paged-product-code?commercialSegmentId=TOP&dealers=${dealer}&legalEntities=${legalEntity}`);
    }


    return {
        getProductCode,
        getProductCodes,
        getPagedProductCode,
        getProductCodesByCommercialCategoryId,
        getCustomProductCode
    };
};